import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Home,
  FolderKanban,
  UserCheck,
  CheckCircle,
  XCircle,
  List,
  Settings as SettingsIcon
} from "lucide-react";
import "./Sidebar.css";

const Sidebar = () => {
  const location = useLocation();

  const navItems = [
    { label: "Dashboard", path: "/", icon: <Home size={19} /> },
    { label: "Projects", path: "/projects", icon: <FolderKanban size={19} /> },
    { label: "Assigned", path: "/assigned", icon: <UserCheck size={19} /> },
    { label: "Completed", path: "/completed", icon: <CheckCircle size={19} /> },
    { label: "Lost Projects", path: "/lost", icon: <XCircle size={19} /> },
    { label: "Price List", path: "/price-list", icon: <List size={19} /> },
    { label: "Settings", path: "/settings", icon: <SettingsIcon size={19} /> },
  ];

  const getIsActive = (path) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <aside className="global-unified-sidebar flex flex-col justify-between h-screen w-[210px] bg-[#181c22] text-white fixed top-0 left-0 bottom-0 z-[1000] select-none overflow-hidden">
      {/* Top Section: Official Brand Logo & Nav Links */}
      <div className="flex-1 flex flex-col min-h-0 z-10">
        {/* FABDIZ Brand Logo */}
        <div className="pt-6 pb-4 px-5">
          <Link
            to="/"
            className="flex items-center transition-opacity hover:opacity-85 no-underline hover:no-underline"
          >
            <img
              src={process.env.PUBLIC_URL + '/FABDIZ-orange-white-logo.svg'}
              alt="FABDIZ"
              className="h-10 w-auto max-w-full object-contain block"
            />
          </Link>
        </div>

        {/* Navigation Items with slightly increased button size */}
        <nav className="flex flex-col gap-1.5 px-3">
          {navItems.map(({ label, path, icon }) => {
            const isActive = getIsActive(path);
            return (
              <Link
                key={label}
                to={path}
                className={`group flex items-center gap-2.5 py-2 px-2.5 rounded-xl text-[13.5px] font-semibold transition-all duration-150 no-underline hover:no-underline focus:no-underline ${isActive
                    ? 'bg-[#843913] text-white shadow-md'
                    : 'text-slate-300 hover:text-white hover:bg-white/5'
                  }`}
              >
                <span
                  className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors shrink-0 ${isActive
                      ? 'bg-[#ad4c17] text-white shadow-sm'
                      : 'text-slate-400 group-hover:text-white group-hover:bg-white/5'
                    }`}
                >
                  {icon}
                </span>
                <span className="truncate tracking-wide no-underline">{label}</span>
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Bottom Visual Section matching user screenshot with setting.webp */}
      <div
        className="relative w-[650px] h-[540px] bg-cover bg-no-repeat flex flex-col justify-end overflow-hidden shrink-0"
        style={{
          backgroundImage: `linear-gradient(to top, rgba(24, 28, 34, 0.15) 0%, rgba(24, 28, 34, 0.65) 50%, #181c22 100%), url(${process.env.PUBLIC_URL + '/settings/setting.webp'})`,
          backgroundPosition: 'right bottom'
        }}
      >
        <div className="p-5 pb-6 relative z-10">
          <div className="font-serif text-[17px] text-white leading-snug font-medium tracking-wide">
            Design<br />
            Spaces,<br />
            Better Lives
          </div>
          <div className="w-8 h-[2.5px] bg-[#ea6e2b] mt-3 rounded-full" />
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;


